@if (!this.noLabel()) {
  <cam-badge class="d-flex" [type]="this.type()" [value]="this.label() | translate"></cam-badge>
} @else {
  <cam-bullet [type]="this.type()"></cam-bullet>
}
